import { InjectionToken } from "@angular/core";

export const ENVSETTINGS = new InjectionToken('environment-settings');
